import { ArrowUp } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { GENERAL } from "@/data/content";
import { gmailTo, ENQUIRY_SUBJECT, CAREERS_SUBJECT, CAREERS_BODY } from "@/lib/email";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-[#080604]">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="flex flex-col justify-between gap-12 lg:flex-row lg:items-start">
          <div>
            <button data-testid="footer-logo" onClick={() => scrollToId("#hero")} className="group flex items-center" aria-label="VERIVISTA Advisory — back to top">
              <span className="flex items-center rounded-sm bg-white px-4 py-2 ring-1 ring-gold/30 transition-all duration-300 group-hover:ring-gold/70 group-hover:shadow-[0_0_28px_rgba(197,160,89,0.25)]">
                <img src="/assets/verivista-logo-full.png" alt="VERIVISTA Advisory LLP" className="h-12 w-auto" />
              </span>
            </button>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-mist">
              Specialised Commercial Management, Project Audit and Project Accounting for film,
              OTT, television, advertising and media productions.
            </p>
          </div>

          <div className="flex gap-16">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">Navigate</p>
              <div className="mt-5 flex flex-col gap-3">
                {[["#solution", "The Model"], ["#flow", "Financial Flow"], ["#industries", "Industries"], ["#contact", "Enquire"]].map(([id, label]) => (
                  <button key={id} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} onClick={() => scrollToId(id)} className="text-left text-sm text-mist transition-colors hover:text-gold">
                    {label}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold">Contact</p>
              <div className="mt-5 flex flex-col gap-3 text-sm text-mist">
                <a data-testid="footer-email" href={gmailTo(GENERAL.email, ENQUIRY_SUBJECT)} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-gold">{GENERAL.email}</a>
                <a data-testid="footer-phone" href={GENERAL.phoneHref} className="transition-colors hover:text-gold">{GENERAL.phone}</a>
                <span>{GENERAL.locations}</span>
              </div>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.28em]" style={{ color: "#C8564D" }}>Careers</p>
              <div className="mt-5 flex flex-col gap-3 text-sm text-mist">
                <span className="max-w-[180px] leading-relaxed">Fresh legs, sharp pencils.</span>
                <a
                  data-testid="footer-careers-link"
                  href={gmailTo("connect@verivistaadvisory.com", CAREERS_SUBJECT, CAREERS_BODY)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-gold"
                >
                  Drop your resume
                </a>
                <a
                  data-testid="footer-careers-whatsapp"
                  href={GENERAL.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-gold"
                >
                  or DM WhatsApp {GENERAL.phone}
                </a>
              </div>
            </div>
          </div>

          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollToId("#hero")}
            aria-label="Back to top"
            className="flex h-12 w-12 shrink-0 items-center justify-center border border-white/15 text-mist transition-all duration-300 hover:border-gold hover:text-gold"
          >
            <ArrowUp size={16} strokeWidth={1.5} />
          </button>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row sm:items-center">
          <p data-testid="footer-copyright" className="font-mono text-[10px] uppercase tracking-[0.18em] text-mist/60">
            © {year} VERIVISTA Advisory LLP · Registered under the LLP Act, 2008, India
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-mist/40">
            Confidentiality assured on every enquiry
          </p>
        </div>
        <p data-testid="footer-registered-office" className="mt-5 font-mono text-[9px] uppercase leading-relaxed tracking-[0.14em] text-mist/40">
          Registered Office: H.no. 394, Jijai Banglow, Mharal Gaon, Mharal Bk, Shahad, Kalyan, Thane, Maharashtra, India 421103 · GSTN 27ABDFV0096R1ZF · LLP Regn. VERIVISTA Advisory LLP / ADC-8123
        </p>
      </div>
    </footer>
  );
}
